import request from '@/utils/http/request'

/* 內頁接口 */


/**
 * 場館列表 
 * @returns 
 */
export async function gyms_list({ name, score, areaCode, serviceType, module, latitude, longitude, sortBy, priceRangeMin, priceRangeMax, filtersTime, selectedTime, pageNumber, pageSize }) {

  return await request.post('/gyms/list', {
    "serviceType": serviceType,
    "module": module,
    'score': score,
    "location": {
      "latitude": latitude,
      "longitude": longitude
    },
    "sortBy": sortBy,
    "filters": {
      "priceRange": {
        "min": priceRangeMin,
        "max": priceRangeMax
      },
      "time": filtersTime,
      'name': name,
      'areaCode': areaCode,
    },
    "selectedTime": selectedTime,
    "pageNumber": pageNumber,
    "pageSize": pageSize
  });
}


/** 
 * 場館詳情
 * @param {Object} params 場館詳情參數 
 * @param {*} params.gymId 主鍵
 * @param {*} params.latitude 緯度
 * @param {*} params.longitude 經度
 * 
 * 
*/
export async function gyms_detail({ gymId, latitude, longitude }) {
  return await request.post('/gyms/detail', {
    gymId,
    location: {
      latitude,
      longitude
    }
  });
}

/** 
 * 場館詳情-場館服務
 * @param {Object} params 場館詳情參數 
 * @param {*} params.gymId 主鍵
 * @param {*} params.latitude 緯度
 * @param {*} params.longitude 經度
 * 
 * 
*/
export async function gyms_services({ gymId, time, sportTypeCode, serviceType }) {
  return await request.post('/gyms/services', {
    gymId,
    time,
    sportTypeCode,
    serviceType
  });
}

/**
 * 場館詳情-服務列表
 * @returns 
 */
export async function gyms_service_list(serviceType, {
  venueCode,
  pageNumber,
  pageSize
}) {
  let url = undefined;
  switch (serviceType) {
    case 'course':
      url = '/courses';
      break;
    case 'linda':
      url = '/temps';
      break;
    case 'activity':
      url = '/activities';
      break;
    case 'competition':
      url = '/matchs';
      break;
  }
  if (url) {
    return await request.post(url, {
      venueCode,
      sportType: '',
      location: {
        longitude: '',
        latitude: ''
      },
      sortBy: '',
      priceMin: '',
      priceMax: '',
      time: '',
      ticketType: '',
      pageNumber,
      pageSize
    });
  }
}



/**
 * 運動類型
 * @returns 
 */
export async function sport_type(gymId) {
  if (gymId) {
    return await request.get(`/gyms/sportTypeList/${gymId}`, {});
  } else {
    return await request.get('/service/sportType', {});
  }
}


/**
 * 服務列表
 * @param {String} serviceType 服務類型。course：課程；linda：臨打；activity：活動；competition：比賽；
 * @param {String} sportType 運動類型
 * @param {String} longitude 經度
 * @param {String} latitude 緯度
 * @param {String} sortBy 排序。priceAsc：點數升序；priceDesc：點數降序；distanceAsc：距離最近。
 * @param {Number} priceMin 最小購買點數
 * @param {Number} priceMax 最大購買點數
 * @param {String} time 服務時間
 * @param {String} ticketType 票卷類型。EARLY_BIRD：早鳥票；OPEN：公開課。
 * @param {Number} pageNumber 分頁頁碼
 * @param {Number} pageSize 分頁條數
 * @returns 
 */
export async function service_list({ mchNo, areaCode, serviceType, sportType, longitude, latitude, sortBy, priceMin, priceMax, time, ticketType, pageNumber, pageSize }) {
  let url = undefined;
  switch (serviceType) {
    case 'course':
      url = '/service/courseList';
      break;
    case 'linda':
      url = '/service/tempList';
      break;
    case 'activity':
      url = '/service/activityList';
      break;
    case 'competition':
      url = '/service/matchList';
      break;
  }
  if (url) {
    return await request.post(url, {
      mchNo,
      areaCode,
      sportType,
      //當前定位 
      location: {
        longitude: longitude,
        latitude: latitude,
      },
      sortBy,
      // priceMin,
      // priceMax,
      time,
      ticketType,
      pageNumber,
      pageSize
    });
  }
}


/**
 * 服務詳情
 * @returns 
 */
export async function service_detail(timeCode) {
  return await request.get(`/service/detail/${timeCode}`, {});
}



export async function area_list() {
  return await request.post(`/area`, {});
}


// 廣告橫幅廣告位廣告列表
/* 
  adType: 廣告類型：1-Banner廣告 2-彈窗廣告 3-側邊欄廣告 4-啟動頁廣告
*/
export async function ad({ adType, displayPosition, pageNumber, pageSize }) {
  return await request.get(`/ad`, {
    params: {
      adType, displayPosition, pageNumber, pageSize
    }
  });
}



